import {useRouter} from "next/router";
import {useEffect, useState} from "react";
import {putCache, withCache} from "@/base/utils/cache";
import {ClearQueryParams} from "@/base/utils/RouterUtils";


export const useReferral = (queryParam: string = "r") => {
	const router = useRouter();

	const [referralCode, setReferralCode] = useState<string | null>(null);

	const retryFromCache = async (code: string | null = null) => {
		return withCache(
			"referral_code",
			60 * 60 * 24 * 14 * 1000,
			async () => {
				return code?.toString();
			},
			true
		).then((codeCached) => {
			if (codeCached)
			{
				setReferralCode(codeCached);
			}

			return codeCached;
		}).catch((e) => {
			setReferralCode(null);

			console.error(e)
			console.error("Failed to cache referral code");
		});
	}

	useEffect(() => {
		const code = router.query[queryParam] || null
		if (code && code.length > 0)
		{
			console.log('[Referral] Setting referral code to: ', code, code.length);
			putCache("referral_code", code.toString()).then(() => {
				ClearQueryParams([queryParam], router);
			})
		}
	}, [router.query[queryParam]]);

	useEffect(() => {
		retryFromCache().then((code) => {
			if (code)
			{
				console.log('[Referral] Using cached referral code: ', code);
			}
		});
	}, []);

	useEffect(() => {
		console.log("[Referral] Referral code changed to: ", referralCode);
	}, [referralCode]);

	const getCurrentUsedCode = () => {
		return referralCode;
	}

	const isUsingReferral = () => {
		return referralCode !== null;
	}

	return {
		getCurrentUsedCode,
		isUsingReferral,
		referralCode
	}
}